import { atom } from "recoil";

const clickedChangeLogoAtom = atom({
  key: "clickedChangeLogoState",
  default: false,
});

export default clickedChangeLogoAtom;
